import { render, staticRenderFns } from "./BancontactToUpSuccess.vue?vue&type=template&id=f54a196e&scoped=true&"
import script from "./BancontactToUpSuccess.vue?vue&type=script&lang=js&"
export * from "./BancontactToUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BancontactToUpSuccess.vue?vue&type=style&index=0&id=f54a196e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54a196e",
  null
  
)

export default component.exports